import { QueryClient } from "@tanstack/react-query";
import { shouldRetryQuery } from "../utils/queryRetry";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes default
      gcTime: 1000 * 60 * 30, // 30 minutes default
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
  },
});
